import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit, inject } from "@angular/core";
import { forkJoin } from "rxjs";

import { AppSettingsService } from "../shared/app-settings-service/app-settings.service";
import { HelpersService } from "../shared/helpers-service/helpers.service";

@Component({
    selector: "app-dev-tools",
    templateUrl: "./dev-tools.component.html",
    standalone: false,
})
export class DevToolsComponent implements OnInit {
    private helpersService = inject(HelpersService);
    private http = inject(HttpClient);
    private appSettingsService = inject(AppSettingsService);

    @Input()
    appBootstrapped = false;
    microServiceList = [];
    appVersions = {};
    helpVersion = "0.0.0.0";

    constructor() {
        const appSettingsService = this.appSettingsService;

        this.helpVersion = appSettingsService.appSettings.HelpVersion;
    }

    ngOnInit() {
        this.init();
    }

    init() {
        const requests = [];
        this.getMicroserviceNamesFromSettings();
        this.microServiceList.forEach((x) => {
            requests.push(
                this.http.get<any>(this.appSettingsService.appSettings[x + "_URL"] + this.appSettingsService.appSettings[x + "_Version"] + "version"),
            );
        });
        forkJoin(requests).subscribe((responses) => {
            responses.forEach((version, key) => {
                this.appVersions[this.microServiceList[key]] = version;
            });
            this.appBootstrapped = true;
            this.helpersService.suppressSpinner();
        });
    }
    getMicroserviceNamesFromSettings() {
        const settings = Object.keys(this.appSettingsService.appSettings);
        settings.forEach((name) => {
            const splitted = name.split("_URL"); // Means its a microservice we support
            if (splitted.length === 2 && splitted[1] === "" && splitted[0] !== "Help" && splitted[0] !== "LocalVM") {
                // Means _URL was found for this name
                this.microServiceList.push(splitted[0]);
            }
        });
    }

    testSentryIntegration(): void {
        console.error("Throwing error");
        throw new Error("Sentry Integration Test");
    }
}
